<template>
    <div class="first-box">
            <p class="title">课程详情</p>
            <div>
                <div class="js-item">
                    <p>负责老师：</p>
                    <div>{{ detail.teacherName||'暂无' }}</div>
                </div>
                <div class="js-item">
                    <p>所属院校：</p>
                    <div>{{ detail.institutions||'暂无' }}</div>
                </div>
                <div class="js-item">
                    <p>开始时间：</p>
                    <div>{{ detail.startTime||'暂无' }}</div>
                </div>
                <div class="js-item">
                    <p>结束时间：</p>
                    <div>{{ detail.endTime||'暂无' }}</div>
                </div>
                <div class="js-item">
                    <p>开课期数：</p>
                    <div>{{ detail.periods?'第'+detail.periods+'期':'暂无' }}</div>
                </div>
                <div class="js-item">
                    <p>课时数量：</p>
                    <div>{{ detail.creditHour||0 }}</div>
                </div>
                <div class="js-item">
                    <p>学分：</p>
                    <div>{{ detail.score||0 }}</div>
                </div>
            </div>
            <div class="btn-box">
                <div class="common-btn" :class="{'ended-btn':!detail.isStudy}" style="margin-right: 2rem;" @click="startStudy">{{ openStatus }}</div>
                <div>
                    <img :src="detail.likes?good:noGood" class="good" style="cursor: pointer;" @click="addOptRecord(OPERATIONTYPE[0])" alt="">
                    <div>{{ numberDivide(detail.up) }}</div>
                </div>
                <div>
                    <img :src="detail.collect?collect:noCollect"  class="sc" style="cursor: pointer;" @click="addOptRecord(OPERATIONTYPE[1])" alt="">
                    <div>{{ numberDivide(detail.sc) }}</div>
                </div>
            </div>
        </div>
</template>

<script>
import { numberDivide,isToLogin } from '@/utils/utils';
import {AddOptRecord} from '@/api/operation';
import {QueryCourseDetail,GetCourseStudyStatus} from '@/api/course';
import { StudyCourse } from '@/api/study';
import Utils from '@/assets/js/Utils';
import { OPERATIONTYPE } from '@/utils/utils';
    export default {
        props:{
            id:{
                default:''
            }
    },
        data(){
            return {
                OPERATIONTYPE,
                good:require('../../../assets/image/operation/good.png'),
                noGood:require('../../../assets/image/operation/no-good.png'),
                collect:require('../../../assets/image/operation/sc.png'),
                noCollect:require('../../../assets/image/operation/no-sc.png'),
                /**是否可以学习 */
                isStudy:false
            }
        },
        methods:{
            numberDivide,
            /**分享 */
            share(){
                navigator.share({
                text: '',
                url: window.location.href
                }).then(console.log('分享成功'))
                .catch(err=>{
                    console.log('分相失败')
                })
            },
            /**获取课程学习状态 */
            getCourseStudyStatus(){
                return new Promise(resolve=>{
                    GetCourseStudyStatus({id:this.courseId}).then(res=>{
                    if(res.code==200){
                        resolve(res.data);
                    }
                })
                })
            },
             /**获取课程详情 */
             queryCourseDetail(){
                QueryCourseDetail({id:this.courseId}).then(res=>{
                    if(res.code==200){
                        this.getCourseStudyStatus().then(res1=>{
                            res.data.isStudy=res1;
                            var data={
                            label:'detail',
                            value:res.data
                        }
                        this.$store.commit('course/changeCourseDetail',data);
                        localStorage.setItem('base_detail',JSON.stringify(res.data));
                        })
                        Utils.$emit('query_recommend');
                    }
                })
            },
            /**添加操作记录 */
            addOptRecord(optType){
                var params={
                        "businessId": this.courseId,
                        "businessType": "course",
                        "optType": optType
                        }
                AddOptRecord(params).then(res=>{
                    if(res.code==200){
                        if(this.detail.likes&&optType==this.OPERATIONTYPE[0]){
                            this.detail.likes=!this.detail.likes;
                        }else if(!this.detail.likes&&optType==this.OPERATIONTYPE[0]){
                            this.detail.likes=!this.detail.likes;
                        }else if(!this.detail.collect&&optType==OPERATIONTYPE[1]){
                            this.detail.collect=!this.detail.collect;
                        }else if(this.detail.collect&&optType==OPERATIONTYPE[1]){
                            this.detail.collect=!this.detail.collect;
                        }
                    }
                })
            },
            /**开始学习 */
            startStudy(){
                if(!this.detail.isStudy)return;
                if(!isToLogin())return;
                StudyCourse({courseId:this.courseId,openCourseId:this.$store.state.course.courseDetailData.detail.openCourseId}).then(res=>{
                    if(res.code==200){
                        localStorage.setItem('course_study_back',this.$route.fullPath);
                        this.$router.push({
                            path:'/course/studyCourse',
                            query:{
                                id:this.courseId,
                                openCourseId:this.$store.state.course.courseDetailData.detail.openCourseId,
                                courseLearningSource:'course_study'
                            }
                        });
                    }
                })
            }
        },
        computed:{
            detail(){
                return this.$store.state.course.courseDetailData.detail;
            },
            operationStatisticsInfo(){
                return this.$store.state.course.operationStatisticsInfo;
            },
            courseId(){
                return this.$route.query.id||this.id;
            },
            /**判断开课状态 */
            openStatus(){
                let userId=this.$store.state.user.userInfo.id;
                let accountType=this.$store.state.user.userInfo.accountType;
                let createId=this.detail.createId;
                if(!this.detail.startTime||!this.detail.endTime||userId==createId||accountType=='0')return '开始学习';
                let startTime=new Date(this.detail.startTime).getTime();
                let endTime=new Date(this.detail.endTime).getTime();
                let now=new Date().getTime();
                if(now<startTime)return '未开始';
                else if(now>endTime)return '已结束';
                else return '开始学习';
            }
        },
        mounted(){
            this.getCourseStudyStatus();
        }
    }
</script>

<style lang="less" scoped>
.title{
    color: #151C34;
    font-size: 2rem;
}
.js-item{
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: 2rem;
    &> :nth-child(1){
        color: #8590B3;
    }
    &> :nth-child(2){
        color: #151C34;
    }
}
.btn-box{
    margin: 2.5rem 0;
    display: flex;
    align-items: center;
    color: #8590B3;
    &> :nth-child(3){
        display: flex;
        align-items: center;
        margin-left: 2rem;
        i{
            margin-right: 0.5rem;
            cursor: pointer;
        }
    }
    &> :nth-child(4){
        display: flex;
        align-items: center;
        margin-left: 2rem;
        i{
            margin-right: 0.5rem;
            cursor: pointer;
        }
    }
}
.dz{
    color: #FF4E00;
}
.sc{
    color: rgb(247,186,42);
}
.ended-btn{
    background: #C0C4CC !important;
    cursor: not-allowed !important;
}
</style>